<template>
  <div class="" v-if="debitNote">
    <el-form :model="formDocument" :rules="rules" ref="formDocument">
      <TopBarTitleComponent title="Editar Nota Débito" :showBackIcon="true">
        <template slot="right-area">
          <div class="d-flex justify-content-end align-items-center">
            <ButtonPrimaryComponent
              title="Guardar"
              @onSaveClick="handleSaveClick"
            />
          </div>
        </template>
      </TopBarTitleComponent>
      <b-container fluid class="pb-4 px-lg-4">
        <b-row>
          <b-col>
            <div class="card box-shadow">
              <div class="card-body">
                <b-row>
                  <b-col xs="12" sm="12" md="4">
                    <el-form-item prop="user_business_invoice_id">
                      <slot name="label">
                        <label class="font-semi-bold m-0 d-block"
                          >Factura</label
                        >
                      </slot>
                      <SelectInvoiceComponent
                        :setUserBusinessInvoiceId="
                          formDocument.user_business_invoice_id
                        "
                        @onChangeSelect="onChangeSelectInvoices"
                        :isDisabled="true"
                      />
                    </el-form-item>
                  </b-col>
                  <b-col xs="12" sm="12" md="4">
                    <el-form-item prop="reason">
                      <slot name="label">
                        <label class="font-semi-bold m-0">Motivo de nota</label>
                      </slot>
                      <el-input
                        type="text"
                        placeholder="Ej: Ajuste de precio"
                        v-model="formDocument.reason"
                      ></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col xs="12" sm="12" md="4">
                    <InputDatePickerComponent
                      @onChangeDatePicker="onChangeDatePicker"
                      prop="emission_date"
                      placeholder=""
                      title="Fecha de emisión"
                      :setDate="formDocument.emission_date"
                      :isDisabledDate="true"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col xs="12" sm="12" md="12">
                    <b-row>
                      <b-col xs="12" sm="12" md="4">
                        <el-form-item prop="">
                          <slot name="label">
                            <label class="font-semi-bold m-0">Empresa</label>
                          </slot>
                          <el-input
                            readonly
                            :value="getClientInvoice && getClientInvoice.name"
                            type="text"
                            placeholder=""
                          ></el-input>
                        </el-form-item>
                      </b-col>
                      <b-col xs="12" sm="12" md="4">
                        <el-form-item prop="">
                          <slot name="label">
                            <label class="font-semi-bold m-0">Correo</label>
                          </slot>
                          <el-input
                            readonly
                            :value="getClientInvoice && getClientInvoice.email"
                            type="text"
                            placeholder=""
                          ></el-input>
                        </el-form-item>
                      </b-col>
                      <b-col xs="12" sm="12" md="4">
                        <el-form-item prop="">
                          <slot name="label">
                            <label class="font-semi-bold m-0">Dirección</label>
                          </slot>
                          <el-input
                            readonly
                            :value="
                              getClientInvoice && getClientInvoice.address
                            "
                            type="text"
                            placeholder=""
                          ></el-input>
                        </el-form-item>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <TableInputProducts
                  isDisabled
                  :isSearchProducts="false"
                  :setProducts="formDocument.products"
                  @onToogleProducts="onToogleProducts"
                />
                <section class="aditional-documents mt-4">
                  <b-row>
                    <b-col xs="12" sm="12" md="4"> </b-col>
                    <b-col xs="12" sm="12" md="4" offset-md="4">
                      <DocumentCalculatorNotes
                        :setProducts="formDocument.products"
                      />
                    </b-col>
                  </b-row>
                </section>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </el-form>
  </div>
</template>

<script>
import ButtonPrimaryComponent from "../../../../components/ButtonPrimary";
import TopBarTitleComponent from "../../../../components/TopBarTitle";
import InputDatePickerComponent from "../../../../components/InputDatePicker";
import TableInputProducts from "../../../components/TableInputProducts";
import SelectInvoiceComponent from "../../../../components/SelectInvoices";
import DocumentCalculatorNotes from "../../../components/DocumentCalculatorNotes";

import Validate from "@/assets/validate";
import debitNoteService from "../services/debitNoteService";

export default {
  name: "DebitNoteEditPage",
  data() {
    return {
      debitNote: null,
      invoice: null,
      formDocument: {
        user_business_invoice_id: "",
        reason: "",
        emission_date: "",
        discount: 0,
        products: []
      },
      rules: {
        user_business_invoice_id: [Validate.rules.required("change")],
        reason: [Validate.rules.required()],
        emission_date: [Validate.rules.required()]
      }
    };
  },
  computed: {
    getClientInvoice() {
      return this.invoice ? this.invoice.client : null;
    }
  },
  methods: {
    onChangeSelectInvoices({ invoice }) {
      const { id } = invoice;
      this.formDocument.user_business_invoice_id = id;
      this.invoice = invoice;
    },
    handleSaveClick() {
      this.$refs.formDocument.validate(async valid => {
        if (valid) {
          if (!this.formDocument.products.length) {
            this.$notifications.warning({
              message: "Debes seleccionar al menos un producto/servicio."
            });
            return false;
          }
          // Auto-rellenar product_detail con el motivo si está vacío (SRI lo requiere)
          this.formDocument.products = this.formDocument.products.map(p => ({
            ...p,
            product_detail:
              p.product_detail ||
              this.formDocument.reason ||
              "Modificación de valor"
          }));
          this.$store.dispatch("toggleRequestLoading");
          try {
            let response = await debitNoteService
              .updateDebitNoteId(this.debitNote.id, this.formDocument)
              .finally(() => {
                this.$store.dispatch("toggleRequestLoading");
              });
            const { success, message } = response.data;
            if (success) {
              this.$notifications.success({ message });
              this.$router.push({
                name: "sales.debitNote.view",
                params: { id: this.debitNote.id }
              });
            }
          } catch (error) {
            return false;
          }
        }
      });
    },
    onChangeDatePicker({ date }) {
      this.formDocument.emission_date = date;
    },
    onToogleProducts({ products }) {
      const p = products.map(p => {
        p.is_debit_note = 1;
        if (!p.product_detail) {
          p.product_detail = p.name || "Modificación de valor";
        }
        return p;
      });
      this.formDocument.products = [...p];
    },
    async getDebitNote() {
      try {
        const { id: debitNoteId } = this.$route.params;
        let response = await debitNoteService.getDebitNoteId(debitNoteId);
        const { data } = response.data;
        this.debitNote = data;
        this.handleDataForm(data);
      } catch (error) {
        return false;
      }
    },
    handleDataForm(debitNote) {
      this.invoice = debitNote.invoice;
      this.formDocument.user_business_invoice_id = debitNote.invoice.id;
      this.formDocument.reason = debitNote.reason || "";
      this.formDocument.emission_date = debitNote.emission_date;
      this.formDocument.products = debitNote.products.map(p => ({
        product_id: p.product?.id || p.product_id,
        user_business_product_id:
          p.user_business_product_id || p.product?.id || p.product_id,
        product: p.product,
        product_quantity: p.product_quantity,
        product_amount: p.product_amount,
        product_detail:
          p.product_detail ||
          (p.product && p.product.name) ||
          debitNote.reason ||
          "Modificación de valor",
        taxes_percentage: p.taxes_percentage,
        is_debit_note: 1
      }));
    }
  },
  components: {
    ButtonPrimaryComponent,
    TopBarTitleComponent,
    InputDatePickerComponent,
    TableInputProducts,
    SelectInvoiceComponent,
    DocumentCalculatorNotes
  },
  mounted() {
    this.getDebitNote();
  }
};
</script>

<style lang="scss" scoped></style>
